<template>
  <div class="upload-container">
    <select name="size-selector" @change="seasonTextChanged" class="with-arrow no-border selector">
      <option value="" disabled selected>Select season</option>
      <option value="fw26">FW26</option>
      <option value="ss27">SS27</option>
      <option value="fw27">FW27</option>
    </select>
    <div class="exception-type-container">
      <p>Please select exception type</p>
      <div class="radio-container">
        <div class="radio">
          <input type="radio" id="positive" name="exception_type" value="Positive" v-model="exceptionType" />
          <label for="positive">Positive</label><br />
        </div>
        <div class="radio">
          <input type="radio" id="negative" name="exception_type" value="Negative" v-model="exceptionType" />
          <label for="negative">Negative</label><br />
        </div>
      </div>
    </div>
    <input
      ref="uploadExceptionsInput"
      type="file"
      class="button hidden-input"
      name="Upload exceptions by product style"
      accept=".xlsx"
      @change="uploadExceptions" />
    <button
      :disabled="isBusy"
      ref="exceptionsUploadBtn"
      class="button upload-button icon-button"
      @click="openFileExplorer">
      Upload exceptions by product style
      <BackstageIcon v-if="isBusy" name="loading"></BackstageIcon>
    </button>
  </div>
</template>

<script lang="ts">
import BackstageIcon from '@/components/common/BackstageIcon.vue';
import { ExceptionService } from '@/services/exception.service';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'product-style-exceptions',
  components: {
    BackstageIcon,
  },
  data() {
    return {
      isBusy: false,
      season: null as string | null,
      exceptionType: 'negative' as string | '',
    };
  },
  methods: {
    openFileExplorer() {
      (this.$refs.uploadExceptionsInput as HTMLInputElement)?.click();
    },

    clearFileInput() {
      const input = this.$refs.uploadExceptionsInput as HTMLInputElement;
      if (input?.value) {
        input.value = '';
      }
    },

    async uploadExceptions(event: Event) {
      this.isBusy = true;
      const productStyleExceptionService = new ExceptionService();
      try {
        if (!this.season || this.season === '') {
          alert('Please input the season id.');

          return;
        }

        if (this.exceptionType === '') {
          alert('Please select the exception type.');

          return;
        }

        const inputEl = event?.target as HTMLInputElement;
        const file = inputEl.files ? inputEl.files[0] : null;

        if (!file) {
          return;
        }

        await productStyleExceptionService.uploadFile(this.season!, this.exceptionType, file);
      } catch (error) {
        console.error('Error uploading exceptions', error);
      } finally {
        this.clearFileInput();
        this.isBusy = false;
      }
    },

    seasonTextChanged(event: Event) {
      const inputEl = event?.target as HTMLInputElement;
      this.season = inputEl.value;
    },
  },
});
</script>

<style scoped lang="scss">
:where(.upload-container) {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 20px;

  .exception-type-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 1rem;
  }

  .radio-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .radio {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    height: auto;
    width: auto;
    vertical-align: initial;
  }

  .season-id-input {
    width: 280px;
    height: 30px;
  }

  .hidden-input {
    display: none;
  }

  .icon-button {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .selector {
    min-width: 250px;
    height: 30px;
    margin-bottom: 1rem;
  }
}
</style>
